import { createSlice, PayloadAction } from '@reduxjs/toolkit';
interface Logout {
  isLogin: boolean;
  isSessionTimeout: boolean;
}
let initialState: Logout = {
  isLogin: true,
  isSessionTimeout: false,
};
const LogoutSlice = createSlice({
  name: 'logout',
  initialState,
  reducers: {
    logout: (state: Logout, action: PayloadAction<{}>) => {
      state.isLogin = false;
    },
    sessionTimeout: (state: Logout, action: PayloadAction<{}>) => {
      state.isSessionTimeout = true;
    },
    clearData: (state: Logout, action: PayloadAction) => {
      state.isLogin = true;
    },
  },
});

export const { logout, sessionTimeout, clearData } = LogoutSlice.actions;

export default LogoutSlice.reducer;
